
import React from 'react';
import { Card, Table } from 'semantic-ui-react';
import _ from 'lodash';

import TargetLink from '../target-link';

const keys = {
  web: 'URL',
  blogUniqueUsers: 'Unique Users',
  blogPageViews: 'Page Views',
  blogDomainAuthority: 'Domain Authority',
  blogPostFrequency: 'Post Frequency',
};

const BlogosphereBlogDetails = ({ details }) => {
  const previous = _.split(details.previousBrandCollaborations, '|');

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          Blog Details
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <Table basic="very" celled fluid>
          <Table.Body>
            {
              _.map(keys, (v, k) => (
                <Table.Row>
                  <Table.HeaderCell>
                    { v }
                  </Table.HeaderCell>
                  <Table.Cell>
                    { details[k] }
                  </Table.Cell>
                </Table.Row>
              ))
            }
          </Table.Body>
        </Table>
      </Card.Content>
      <Card.Content>
        <Card.Header>
          Previous brand collaborations
        </Card.Header>
      </Card.Content>
      <Card.Content>
        { _.map(previous, p => (
          <p><TargetLink renderIf href={p}>{ p }</TargetLink></p>
        )) }
      </Card.Content>
    </Card>
  );
};

export default BlogosphereBlogDetails;



/** WEBPACK FOOTER **
 ** ./src/components/blogosphere-blog-details/index.js
 **/